module.exports = __webpack_public_path__ + "static/Uniteller_Visa_MasterCard_MIR-ed9929ac43e6ff1bdc64d3b515455b14.png";